module.exports = __webpack_public_path__ + "static/img/bg-vip1.01a618d6.png";